import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

// PrimeNG imports
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

export interface SuccessStory {
  id?: string;
  coverImage?: string;
  title: string;
  description: string;
  linkUrl: string;
}

@Component({
  selector: 'app-success-story-item',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule,
    CardModule
  ],
  templateUrl: './success-story-item.component.html',
  styleUrls: ['./success-story-item.component.css']
})
export class SuccessStoryItemComponent {
  @Input({ required: true }) story!: SuccessStory;
  @Input({ required: true }) index!: number;
  @Output() edit = new EventEmitter<{ story: SuccessStory; index: number }>();
  @Output() remove = new EventEmitter<{ story: SuccessStory; index: number }>();

  onEdit(): void {
    this.edit.emit({ story: this.story, index: this.index });
  }

  onRemove(): void {
    this.remove.emit({ story: this.story, index: this.index });
  }
}